<template><div><code-example only-show="demo" class="d-d-block">
<dt-root-layout
:fixed="false"
class="d-w100p d-h-500"
>
<template
  #header
>
  <div class="d-h-100 d-bgc-purple-100">Header</div>
</template>
<template
  #sidebar
>
  <div class="d-w-200 d-h100p d-bgc-black-100"><div>Sidebar item 1</div><div>Sidebar item 2</div><div>Sidebar item 3</div></div>
</template>
<div class="d-bgc-green-100 d-w100p d-h100p">Content</div>
<template
  #footer
>
  <div class="d-h-100 d-bgc-gold-100">Footer</div>
</template>
</dt-root-layout>
</code-example>
<!-- <component-combinator component-name="DtRootLayout" /> -->
<h2 id="base-style" tabindex="-1" class="d-docsite--header-2">Base Style <a class="header-anchor d-link d-docsite--link d-link" href="#base-style" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">A root layout consists of a header, body, sidebar and footer. Content can optionally be passed into the slots which
will be displayed in the respective area. The sidebar is designed to be responsive and will reposition above the
body according to the <code v-pre>responsiveBreakpoint</code> prop.</p>
<code-example class="d-d-block" source-code='&lt;dt-root-layout
:fixed=&quot;false&quot;
class=&quot;d-w100p d-h-500&quot;
&gt;
&lt;template
  #header
&gt;
  &lt;div class=&quot;d-h-100 d-bgc-purple-100&quot;&gt;Header&lt;/div&gt;
&lt;/template&gt;
&lt;template
  #sidebar
&gt;
  &lt;div class=&quot;d-w-200 d-h100p d-bgc-black-100&quot;&gt;&lt;div&gt;Sidebar item 1&lt;/div&gt;&lt;div&gt;Sidebar item 2&lt;/div&gt;&lt;div&gt;Sidebar item 3&lt;/div&gt;&lt;/div&gt;
&lt;/template&gt;
&lt;div class=&quot;d-bgc-green-100 d-w100p d-h100p&quot;&gt;Content&lt;/div&gt;
&lt;template
  #footer
&gt;
  &lt;div class=&quot;d-h-100 d-bgc-gold-100&quot;&gt;Footer&lt;/div&gt;
&lt;/template&gt;
&lt;/dt-root-layout&gt;'>
<dt-root-layout
:fixed="false"
class="d-w100p d-h-500"
>
<template
  #header
>
  <div class="d-h-100 d-bgc-purple-100">Header</div>
</template>
<template
  #sidebar
>
  <div class="d-w-200 d-h100p d-bgc-black-100"><div>Sidebar item 1</div><div>Sidebar item 2</div><div>Sidebar item 3</div></div>
</template>
<div class="d-bgc-green-100 d-w100p d-h100p">Content</div>
<template
  #footer
>
  <div class="d-h-100 d-bgc-gold-100">Footer</div>
</template>
</dt-root-layout>
</code-example>
<h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="header-sticky" tabindex="-1" class="d-docsite--header-3">Header Sticky <a class="header-anchor d-link d-docsite--link d-link" href="#header-sticky" aria-hidden="true">#</a></h3>
<code-example class="d-d-block" source-code='&lt;div
  class=&quot;d-h-500 d-of-scroll&quot;
&gt;
  &lt;dt-root-layout
    header-sticky
    class=&quot;d-w100p d-h-500&quot;
  &gt;
    &lt;template
      #header
    &gt;
      &lt;div class=&quot;d-h-100 d-bgc-purple-100&quot;&gt;Header&lt;/div&gt;
    &lt;/template&gt;
    &lt;template
      #sidebar
    &gt;
      &lt;div class=&quot;d-w-200 d-h100p d-bgc-black-100&quot;&gt;&lt;div&gt;Sidebar item 1&lt;/div&gt;&lt;div&gt;Sidebar item 2&lt;/div&gt;&lt;div&gt;Sidebar item 3&lt;/div&gt;&lt;/div&gt;
    &lt;/template&gt;
      &lt;div class=&quot;d-bgc-green-100 d-w100p d-h100p&quot;&gt;Content&lt;/div&gt;
    &lt;template
      #footer
    &gt;
      &lt;div class=&quot;d-h-100 d-bgc-gold-100&quot;&gt;Footer&lt;/div&gt;
    &lt;/template&gt;
  &lt;/dt-root-layout&gt;
&lt;/div&gt;'>
<div
  class="d-h-500 d-of-scroll"
>
  <dt-root-layout
    header-sticky
    class="d-w100p d-h-500"
  >
    <template
      #header
    >
      <div class="d-h-100 d-bgc-purple-100">Header</div>
    </template>
    <template
      #sidebar
    >
      <div class="d-w-200 d-h100p d-bgc-black-100"><div>Sidebar item 1</div><div>Sidebar item 2</div><div>Sidebar item 3</div></div>
    </template>
      <div class="d-bgc-green-100 d-w100p d-h100p">Content</div>
    <template
      #footer
    >
      <div class="d-h-100 d-bgc-gold-100">Footer</div>
    </template>
  </dt-root-layout>
</div>
</code-example>
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Root Layout should be used as the top level component for a route. All other components on the page should be nested
within one of the root layout's slots. The root layout should not be nested within any other elements or components.</p>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="rootlayout" /><h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The RootLayout component uses
<a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element#content_sectioning" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Content Sectioning</a>
elements <code v-pre>&lt;header&gt;</code>, <code v-pre>&lt;aside&gt;</code>, <code v-pre>&lt;main&gt;</code>, and <code v-pre>&lt;footer&gt;</code> which automatically define
<a href="https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles#landmark_roles" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">ARIA Landmark Roles</a>
on the page.</p>
<p class="d-docsite--paragraph">If you have navigation links contained within any of the slots Root Layout provides these should be enclosed in a <code v-pre>&lt;nav&gt;</code>
<a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/nav" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Nav Section</a>.
The RootLayout component will not do this for you.</p>
<p class="d-docsite--paragraph">The sidebar will not automatically wrap to be above the main content by default.
This can be changed via the <code v-pre>responsiveBreakpoint</code> prop if desired.</p>
</div></template>


